/** @format */

export const getBaseUrl = () => {
	return (
		process.env.REACT_APP_API_URL || 'https://morabishooo.com/api/v1'
	);
};

export const getBroadcastUrl = () => {
	let urlParsed = new URL(getBaseUrl());
	let { origin } = urlParsed;

	return `${origin}/broadcasting/auth`;
};
